import { debounce } from "throttle-debounce";

import initAxios from "../api/initAxios";
import callWindowFunction from "../utils/callWindowFunction";

class WebSockets {
  errorMessage = null;

  constructor(rootStore, getWsTokenUrl, webSocketUrl) {
    this.rootStore = rootStore;

    this.socket = null;

    this.wsConnectionCount = 0;

    this.isWsStarted = false;

    this.getWsTokenUrl = getWsTokenUrl;
    this.webSocketUrl = webSocketUrl;

    this.axios = initAxios({ withCredentials: true });
  }

  reopenWsConnection = debounce(500, false, () => {
    if (this.wsConnectionCount === 3) {
      this.rootStore.notifications.startUpdateIntervalNotifications();
    }

    this.wsConnectionCount += 1;
    const lag =
      5000 * this.wsConnectionCount < 60000
        ? 5000 * this.wsConnectionCount
        : 60000;

    window.setTimeout(() => {
      if (!this.socket || this.socket.readyState === WebSocket.CLOSED) {
        this.getToken();
      }
    }, lag);
  });

  closeWSConnection = () => {
    this.isWsStarted = false;

    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.close();
    }
  };

  getToken = () => {
    this.axios
      .post(this.getWsTokenUrl)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          return res;
        }
        return false;
      })
      .then((res) => {
        if (res) {
          this.openWebSocketConnection(res.data);
        }
      })
      .catch((error) => {
        console.log(error);
        this.isWsStarted = false;
        if (this.rootStore.crossDomain.isMaster) {
          this.reopenWsConnection();
        }
      });
  };

  notificationMasterAction = () => {
    if (!this.rootStore.crossDomain.isWasLed) {
      this.rootStore.notifications.reloadNotifications();
    }

    if (!this.isWsStarted) {
      if (this.getWsTokenUrl && this.webSocketUrl) {
        this.getToken();
      } else {
        this.rootStore.notifications.startUpdateIntervalNotifications();
      }
    }
  };

  finalNotificationMasterAction = () => {
    this.rootStore.notifications.closeUpdateInterval();
    this.closeWSConnection();
  };

  openWebSocketConnection = (token) => {
    this.socket = new WebSocket(
      `${this.webSocketUrl}/?token=${token.token}&firmId=${token.firm_id}&contactId=${token.contact_id}`
    );

    this.socket.onopen = () => {
      this.isWsStarted = true;

      if (this.wsConnectionCount >= 3) {
        this.rootStore.notifications.closeUpdateInterval();
      }

      this.wsConnectionCount = 0;

      this.socket.send(`{
        "action_code": 0,
        "entity_queries": [
          {
            "action": "changed",
            "project_name": "atinotifications",
            "entity_name": "totalUnreadCounter",
            "additional_parameters": {}
          },
          {
            "action": "sent",
            "project_name": "atinotifications",
            "entity_name": "webPush",
            "additional_parameters": {}
          },
          {
            "action": "allread",
            "project_name": "atinotifications",
            "entity_name": "notification",
            "additional_parameters": {}
          }
        ]
      }`);

      this.socket.onmessage = (event) => {
        let data = {};
        try {
          data = JSON.parse(event.data);
        } catch (e) {
          console.error("Bad event message");
        }

        this.wsMessageHandler(data);

        callWindowFunction("publishToEventBus", [
          {
            subject: "frontWSNotificationMessage",
            destination: "exceptThisTab",
            tabId: this.rootStore.profile.tabId,
            body: data,
          },
        ]);
        callWindowFunction("publishToEventBus", [
          {
            subject: "notificationMessageFromHeader",
            destination: "all",
            tabId: this.rootStore.profile.tabId,
            body: data,
          },
        ]);
      };
    };

    this.socket.onclose = (event) => {
      console.log(`code: ${event.code} reason: ${event.reason}`);
      console.log("event:", event);
      this.errorMessage = `code: ${event.code} reason: ${event.reason}`;
      this.isWsStarted = false;

      if (this.rootStore.crossDomain.isAuthorizedMaster) {
        this.reopenWsConnection();
      }
    };

    this.socket.onerror = (error) => {
      console.log(`error: ${error.message}`);
      console.log("event:", error);
      this.errorMessage = error.message;
      this.isWsStarted = false;

      if (this.rootStore.crossDomain.isMaster) {
        this.reopenWsConnection();
      }
    };
  };

  wsMessageHandler = (data) => {
    if (data.entity) {
      this.rootStore.feeds.listenNtf(data);

      if (data.entity_name === "totalUnreadCounter") {
        const unreadCount = data.entity.count;

        this.rootStore.notifications.updateNotificationsTotal(unreadCount);
      }
    }
  };

  getWSInfo = () => [
    `Is notification ws working: ${this.isWsStarted}`,
    `Count of connection to chat ws: ${this.wsConnectionCount}`,
    `Error message: ${this.errorMessage}`,
  ];
}

export default WebSockets;
